module.exports = __webpack_public_path__ + "static/img/slide_2.bb0b2ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/slider/slide_2.png
// module id = fguY
// module chunks = 0